import { Mail, Phone, Linkedin, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";
import { useSite } from "@/context/SiteContext";

const Footer = () => {
    const { content } = useSite();
    const year = new Date().getFullYear();

    return (
        <footer data-testid="footer" className="bg-navy text-slate-300">
            <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
                <div className="grid gap-10 md:grid-cols-3">
                    <div>
                        <div className="inline-flex rounded-xl bg-white/95 p-2.5">
                            <Logo />
                        </div>
                        <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">{content.brand.tagline}</p>
                    </div>

                    <nav aria-label="Footer navigation">
                        <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">Quick links</h3>
                        <ul className="mt-4 space-y-2.5">
                            {content.nav.map((item) => (
                                <li key={item.href}>
                                    <a
                                        href={item.href}
                                        data-testid={`footer-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                                        className="inline-flex items-center gap-1 text-sm text-slate-300 transition-colors hover:text-white"
                                    >
                                        {item.label} <ArrowUpRight className="h-3.5 w-3.5" />
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div>
                        <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">Contact</h3>
                        <ul className="mt-4 space-y-3 text-sm">
                            <li>
                                <a href={`mailto:${content.contact.email}`} data-testid="footer-email-link" className="flex items-center gap-2.5 transition-colors hover:text-white">
                                    <Mail className="h-4 w-4 text-amberct" /> {content.contact.email}
                                </a>
                            </li>
                            <li>
                                <a href={`tel:${content.contact.phone.replace(/\s/g, "")}`} data-testid="footer-phone-link" className="flex items-center gap-2.5 transition-colors hover:text-white">
                                    <Phone className="h-4 w-4 text-amberct" /> {content.contact.phone}
                                </a>
                            </li>
                            <li>
                                <a href={content.contact.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin-link" className="flex items-center gap-2.5 transition-colors hover:text-white">
                                    <Linkedin className="h-4 w-4 text-amberct" /> LinkedIn
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row">
                    <p data-testid="footer-copyright">© {year} {content.brand.name}. All rights reserved.</p>
                    <a href="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-slate-300">
                        Admin Studio
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
